import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangeIconComponent } from '@front/app/modules/shared/shared-icon/date-range-icon/date-range-icon.component';

@NgModule({
  declarations: [DateRangeIconComponent],
  imports: [CommonModule],
  exports: [DateRangeIconComponent]
})
export class SharedIconModule {}
